import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { HttpClientModule } from '@angular/common/http';
import { AuthEffects } from 'auth';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { RootStoreModule } from './modules/store/root-store.module';
import { reducers } from './core/app.states';
import { EffectsModule } from '@ngrx/effects';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app-routing-module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PtImageMappingModule } from './modules/pt-image-mapping/pt-image-mapping.module';
import { ViewImageModule } from './modules/view-images/view-image.module';
import { ObervableService } from './service/obervable.service';
import { ConstantService } from './service/constant.service';
import { ExcelExportService } from './service/excel-export.service';
import {MatPaginatorModule} from '@angular/material/paginator';
import { CapELSSHeaderModule, CapHeaderConfigProvider } from '@cap/cap-ui';
import { HeaderConfigProvider, HeaderConfigService } from './core/config/header-config.service';

@NgModule({
	declarations: [
		AppComponent
	],
	imports: [
		HttpClientModule,
		MatPaginatorModule,
		BrowserAnimationsModule,
		BrowserModule,
		RouterModule,
		CoreModule,
		SharedModule,
		RootStoreModule,
		StoreModule.forRoot(reducers),
		EffectsModule.forRoot([AuthEffects]),
		AppRoutingModule,
		ViewImageModule,
		PtImageMappingModule,
		CapELSSHeaderModule.forRoot({
            config: {
                provide: CapHeaderConfigProvider,
                useClass: HeaderConfigProvider,
            },
        }),
	],
	exports: [],
	providers: [
		ObervableService,
		ConstantService,
		ExcelExportService,
		{
            provide: APP_INITIALIZER,
            useFactory: (HeaderConfigService: HeaderConfigService) => () =>
                HeaderConfigService.init(),
            deps: [HeaderConfigService],
            multi: true,
		},
		{ provide: 'googleTagManagerId', useValue: 'GTM-WP7HZ99', multi: true }
	],
	bootstrap: [AppComponent]
})
export class AppModule { }
